const style = {
  searchBoxContainer: {
    display: 'flex',
    flexDirection: 'row',
    gap: '8px',
    width: '100%',
    maxWidth: '70%'
  },
  searchBoxInput: {
    width: '100%',
    minWidth: 0
  },
  listBox: {
    minWidth: 0
  }
}

export default style
